import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Demo, { DemoSliderControl } from '@/components/Demo';

import Snippet from './Snippet';
import OutputWrapper from './OutputWrapper';

function RemDemo() {
  return (
    <Demo
      id="rem-demo"
      initialValues={{
        fontSize: 16,
      }}
      outputWrapper={OutputWrapper}
      controls={[
        <DemoSliderControl
          key="fontSize"
          id="fontSize"
          label="font-size"
          min={12}
          max={48}
          previewRenderer={(val) => `${val}px`}
        />,
      ]}
      controlPosition="top"
    >
      {({ fontSize }) => (
        <OuterWrapper>
          <Wrapper style={{ fontSize: `${fontSize}px` }}>
            <Title>Hello World</Title>
            <p>This is a paragraph with some words and things.</p>
          </Wrapper>
          <Snippet
            code={generateCodeSnippet({ fontSize })}
            minCodeHeight="12.75rem"
          />
        </OuterWrapper>
      )}
    </Demo>
  );
}

function generateCodeSnippet({ fontSize }: { fontSize: number }) {
  return `html {
  font-size: ${fontSize}px;
}
h1 {
  font-size: 2rem;
}`;
}

const OuterWrapper = styled.div`
  width: 100%;
`;

const Wrapper = styled.div`
  padding: 16px;
  margin-bottom: 1rem;

  @media ${BREAKPOINTS.smAndLarger} {
    padding: 32px;
    margin-bottom: 0;
  }
`;

const Title = styled.p`
  font-size: 2em;
`;
const Paragraph = styled.p`
  font-size: 1em;
`;

export default RemDemo;
